<template>
  <v-container fluid class="grey lighten-4 py-8">
    <!-- Overlays (Lógica intacta) -->
    <v-overlay :value="cargando" fixed z-index="999">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
        <div class="mt-3 white--text font-weight-bold">{{ chargeMessage }}</div>
      </div>
    </v-overlay>

    <!-- Barra de Filtros y Búsqueda -->
    <v-row justify="center" class="mb-6 mx-1">
      <v-col cols="12" md="10" lg="8">
        <v-card elevation="2" class="rounded-xl pa-2">
          <v-row align="center" no-gutters>
            <v-col cols="12" sm="4" md="3">
              <v-select
                v-model="selectedState"
                :items="[
                  { text: 'Todos los estados', value: 'Todos' },
                  { text: 'Confirmados', value: 'sale' },
                  { text: 'Presupuestos', value: 'draft' }
                ]"
                hide-details
                flat
                solo
                prepend-inner-icon="mdi-filter-variant"
                class="state-select"
              ></v-select>
            </v-col>
            <v-divider vertical class="d-none d-sm-block mx-2"></v-divider>
            <v-col cols="12" sm="7" md="8">
              <v-text-field
                v-model="search"
                label="Buscar por pedido, artículo o referencia..."
                prepend-inner-icon="mdi-magnify"
                flat
                hide-details
                solo
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="auto" class="text-right" v-if="newOrder">
              <v-btn icon color="primary" @click="reloadData" class="ml-2">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Listado de Pedidos -->
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <v-hover v-for="(item, index) in filteredOrders" :key="index" v-slot="{ hover }">
          <v-card
            :elevation="hover ? 6 : 1"
            class="mb-4 rounded-lg order-card transition-swing"
            outlined
          >
            <!-- Cabecera estilo Identificación -->
            <div class="bg-header px-4 py-2 d-flex align-center justify-space-between">
              <div class="d-flex align-center">
                <v-chip label small color="primary lighten-5" class="primary--text font-weight-bold mr-3">
                  ID: {{ item.name }}
                </v-chip>
                <span class="text-caption font-weight-bold grey--text text-uppercase tracking-wider">
                  REF: {{ item.client_order_ref || 'Sin referencia' }}
                </span>
              </div>
              
              <!-- Acción Cancelar (Esquina) -->
              <v-tooltip v-if="inDate(item)" left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small color="red lighten-2" v-bind="attrs" v-on="on" @click="makeOrder(item, 0)">
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar pedido</span>
              </v-tooltip>
            </div>

            <v-divider></v-divider>

            <v-card-text class="pa-4">
              <v-row align="center">
                <!-- Información Principal -->
                <v-col cols="12" md="8">
                  <v-row dense>
                    <v-col cols="12" sm="6" class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-2">mdi-calendar-clock</v-icon>
                      <span class="text-body-2 font-weight-medium">{{ formatDate(item.date_order) }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex align-center">
                      <v-icon small color="grey darken-1" class="mr-2">mdi-account-circle-outline</v-icon>
                      <span class="text-body-2 text-truncate">{{ item.partner_id[1] || 'Usuario' }}</span>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-2 d-flex align-center">
                      <v-chip 
                        x-small 
                        :color="item.state == 'sale' ? 'success' : 'amber darken-2'" 
                        dark 
                        class="font-weight-bold px-3"
                      >
                        {{ item.state == "sale" ? "PEDIDO CONFIRMADO" : "PRESUPUESTO" }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="6" class="mt-2 d-flex align-center">
                       <v-icon small color="green darken-2" class="mr-2">mdi-cash-multiple</v-icon>
                       <span class="text-h6 font-weight-black green--text text--darken-3">{{ item.amount_total }} €</span>
                    </v-col>
                  </v-row>
                </v-col>

                <!-- Botones de Acción Derecho -->
                <v-col cols="12" md="4" class="text-md-right border-left-md">
                  <div class="d-flex flex-column align-md-end">
                    
                    <!-- Alerta observación -->
                    <v-alert
                      v-if="productoEnObservacion(item)"
                      dense
                      text
                      type="error"
                      class="text-caption pa-1 mb-2 w-100"
                    >
                      <div class="d-flex align-center">
                        <span>Producto en observación</span>
                      </div>
                    </v-alert>

                    <v-btn
                      v-if="item.state == 'draft'"
                      depressed
                      block
                      color="#FF7043"
                      class="white--text rounded-lg mb-2"
                      :disabled="productoEnObservacion(item)"
                      @click="makeOrder(item, 1)"
                    >
                      <v-icon left>mdi-check-circle-outline</v-icon>
                      Confirmar Pedido
                    </v-btn>

                    <v-btn
                      outlined
                      block
                      color="blue darken-1"
                      class="rounded-lg"
                      @click="toggleOrderDetails(item, index)"
                    >
                      <v-icon left>{{ selectedOrderIndex === index ? "mdi-chevron-up" : "mdi-eye-outline" }}</v-icon>
                      {{ selectedOrderIndex === index ? "Ocultar Detalles" : "Ver Detalles" }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <!-- Expansión de Detalles -->
            <v-expand-transition>
              <div v-if="selectedOrderIndex === index" class="grey lighten-5 border-top">
                <v-container>
                  <order-details :order="selectedOrder"></order-details>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Paginación -->
    <v-row justify="center" class="mt-8 pb-8">
      <v-pagination
        v-model="currentPage"
        :length="totalPages"
        :total-visible="7"
        circle
        color="primary"
        @input="changePage"
      ></v-pagination>
    </v-row>

    <!-- Diálogos (Sin cambios en lógica, solo diseño limpio) -->
    <v-dialog v-model="orderDialog" max-width="450">
      <v-card class="rounded-lg pa-4">
        <v-card-title class="headline d-flex align-center">
          <v-icon large color="primary" class="mr-3">
            {{ processingOrderVal == 1 ? "mdi-cart-check" : "mdi-delete-alert" }}
          </v-icon>
          {{ processingOrderVal == 1 ? "Confirmar" : "Cancelar" }} pedido
        </v-card-title>
        <v-card-text class="text-body-1 py-4">
          ¿Deseas {{ processingOrderVal == 1 ? "confirmar" : "cancelar" }} el pedido 
          <strong>{{ repeatingOrder?.name }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="orderDialog = false">Atrás</v-btn>
          <v-btn 
            :color="processingOrderVal == 1 ? 'success' : 'error'" 
            depressed 
            class="rounded-pill px-6" 
            @click="processOrder()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de respuesta/alerta -->
    <v-dialog v-model="dialog" max-width="450">
      <v-alert
        :type="alertType"
        class="ma-0 rounded-lg"
        prominent
      >
        <div class="d-flex align-center justify-space-between">
          <span>{{ error_text }}</span>
          <v-btn text small @click="dialog = false" class="ml-4">Cerrar</v-btn>
        </div>
      </v-alert>
    </v-dialog>

  </v-container>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import OrderDetails from "@/components/utils/OrderDetails.vue";
import moment from 'moment-timezone';
import { jwtDecode } from "jwt-decode";

export default {
  components: {
    OrderDetails,
  },

  data() {
    return {
      selectedOrder: {},
      selectedOrderIndex: null,

      //Dialog de confirmacion pedido
      dialog: false,
      error_text: "",
      alertType: "",
      chargeMessage: "",

      cargando: false,

      selectedState: "Todos",

      //Dialog de confirmar pedido
      repeatingOrder: null,
      orderDialog: false,
      formValid: false,
      processingOrderVal: null,
      userName: "",
      orderReference: "",

      //Buscador de pedido
      search:"",

      //Fecha de hoy
      today: null,

      //formato paginado
      currentPage: 1,
      itemsPerPage: 20,
      totalPages: 1,
    };
  },

  mounted() {
    this.today = moment().tz("Europe/Madrid");
  },

  watch: {
    search() {
      //reestablecemos los valores predeterminados de la paginacion
      this.currentPage = 1;
    },
  },

  computed: {
    ...mapState(["orders", "newOrder", "token"]),

    filteredOrders() {
      const orderFilter = this.selectedState === "Todos" ? this.orders : 
              this.orders?.filter((order) => order?.state === this.selectedState);

      if (this.search == "" || this.search == null) return this.createArticles(orderFilter);

      const toLower = this.search?.toLocaleLowerCase();

      //Hacer busqueda de pedido
      return this.createArticles(orderFilter.filter((pedido) => {
        //Comprobacion de pedido por id o nombre
        const matchPedido = String(pedido.name).toLocaleLowerCase().includes(toLower) ||
                            String(pedido.id).toLocaleLowerCase().includes(toLower);

        //Busqueda por referencia de pedido
        const matchOrderRef = String(pedido.client_order_ref).toLocaleLowerCase().includes(toLower);

        //Busqueda por nombre de articulo o id articulo
        const matchArticle = pedido.articles.some((art) =>
          String(art.default_code || "").toLocaleLowerCase().includes(toLower) ||
          String(art.product_name || "").toLocaleLowerCase().includes(toLower)
        );

        return matchPedido || matchOrderRef || matchArticle;
      }));
    }
  },

  methods: {
    ...mapGetters(["articlesInCart", "getPartnerId"]),
    ...mapActions(["postDataWithReturn", "addToCart", "removeFromCart", "setOrders", "getData", "changeNewOrder"]),

    //funcion para devolver el tamaño de pagina de articulos y pagina de articulos (paginacion)
    createArticles(array) {
      //calculamos el total de paginas
      this.totalPages = Math.ceil(array.length / this.itemsPerPage);

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;

      const createdArticles = array.slice(start, end);

      return createdArticles;
    },
    //Funcion para cambiar de pagina (paginacion)
    changePage(page) {
      // console.log("page", page);
      this.currentPage = page;
      this.scrollToTop();
    },
    //Funcion para scrollear a la parte de arriba de la aplicacion al cambiar de pagina (paginacion)
    scrollToTop() {
      const forceScrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      };

      forceScrollToTop();

      // Forzar un ajuste después de un retraso
      setTimeout(() => {
        forceScrollToTop();
      }, 300);

      // Usar requestAnimationFrame para precisión adicional
      const smoothScroll = () => {
        if (window.scrollY > 0) {
          forceScrollToTop();
          requestAnimationFrame(smoothScroll);
        }
      };
      requestAnimationFrame(smoothScroll);
    },

    //Funcion para devolver booleano si existe porducto en observacion
    productoEnObservacion(item){
      const articlesDC = item.articles.filter((art) => art.default_code != false);
      return articlesDC.filter((art) => art.default_code == "OBSERVACION" || art.default_code.includes("OBS_")).length > 0;
    },

    //Funcion para saber si se puede eliminar el pedido (no deben pasar mas de x dias desde que se hizo el pedido)
    inDate(item) {
      const momentDate = moment(item.date_order, "YYYY-MM-DD HH:mm:ss");
      const today_formatted = moment(this.today, "YYYY-MM-DD HH:mm:ss");
      
      const diff = today_formatted.diff(momentDate, "days");
      // console.log(diff);

      return diff > 4 ? false : true;
    },
    formatDate(date) {
      return moment.utc(date).tz("Europe/Madrid").format("YYYY-MM-DD HH:mm:ss");
    },

    //Mostrar detalles de pedido(articulos)
    toggleOrderDetails(item, index) {
      if (this.selectedOrderIndex !== null && index == this.selectedOrderIndex) {
        this.selectedOrder = {};
        this.selectedOrderIndex = null;
      } else {
        this.selectedOrder = item;
        this.selectedOrderIndex = index;
      }
    },

    //Recoger pedidos desde odoo
    async reloadData() {
      this.selectedOrder = {};
      this.selectedOrderIndex = null;

      this.chargeMessage = "Recogiendo pedidos"
      this.cargando = true;
      // const partner_id = 70 //borrar
      const partner_id = this.getPartnerId()
      try {
        const { orders } = await this.getData({ path: `django/portal/get_orders/?partner_id=${partner_id}` });
        this.setOrders(orders);

        this.changeNewOrder(false);
      } catch {
        //desplegar dialogo error
        console.error("Error al crear pedido: ", e);
        this.dialog = true;
        this.error_text = "Error al cargar datos de pedido, intentelo de nuevo";
        this.alertType = "error";
      } finally {
        this.cargando = false;
        this.currentPage = 1; //(paginacion)
      }
    },

    //Funcion para hacer el pedido (mostrar dialog de pedido)
    makeOrder(item, val) {
      this.userName = jwtDecode(localStorage.getItem("token")).username;
      this.repeatingOrder = item;
      this.orderDialog = true;
      this.processingOrderVal = val;
      // if (item.state == 'sale') await this.repeatOrder(item);
      // else if (item.state == 'draft') await this.confirmOrder(item);
    },

    async processOrder() {
      if (this.processingOrderVal == 0) await this.cancelOrder();
      else if(this.processingOrderVal == 1) await this.confirmOrder();
      else return null; 
    },

    //Funcion para confirmar pedido
    async confirmOrder() {
      this.chargeMessage = `Confirmando pedido ${this.repeatingOrder.name}`;
      this.cargando = true;
      this.orderDialog = false;
      
      try {
          console.log("Productos: ", this.repeatingOrder);
          const { sale_order_id: sale_order_id } = await this.postDataWithReturn({ path: "django/portal/confirm_order/", body: this.repeatingOrder.id });
          // console.log(sale_order_id);

          //desplegar dialog correcto
          this.dialog = true;
          this.error_text = "Pedido confirmado correctamente";
          this.alertType = "success";

          //para saber que hay nuevos pedidos
          this.changeNewOrder(true);
        } catch(e) {
          //desplegar dialogo error
          console.error("Error al crear pedido: ", e);
          this.dialog = true;
          this.error_text = "Error al confirmar pedido";
          this.alertType = "error";
        } finally {
          this.cargando = false;
          this.repeatingOrder = null;
        }
    },

    //Funcion para cancelar un pedido
    async cancelOrder() {
      this.chargeMessage = `Cancelando pedido ${this.repeatingOrder.name}`;
      this.cargando = true;
      this.orderDialog = false;
      try {
        const { success: success } = await this.postDataWithReturn({ path: "django/portal/cancel_order/", body: this.repeatingOrder.id });
        console.log(success);

        //desplegar dialog correcto
        this.dialog = true;
        this.error_text = "Pedido cancelado correctamente";
        this.alertType = "success";

        //para saber que hay modificacion en los pedidos
        this.changeNewOrder(true);

      } catch(e) {
        console.error("Error al cancelar el pedido", e);
        this.dialog = true;
        this.error_text = "Error al cancelar pedido, intentelo de nuevo";
        this.alertType = "error";
      } finally {
        this.cargando = false;
      }
    },

    //Funcion para repetir pedido(no utilizado)
    async repeatOrder(type) {
      this.chargeMessage = "Realizando pedido"
      this.cargando = true;
      this.orderDialog = false;
      
      const payload = {
        // partner_id: 70, //borrar
        partner_id: this.getPartnerId(),
        articles: this.repeatingOrder.articles.map(({ product_id, ...rest }) => ({
          ...rest,
          id: product_id
        })),
        tag_name: "PORTAL",
        type: type,
        order_reference: `${ this.userName }${ this.orderReference? ` ${this.orderReference}` : "" }`,
      };
      try {
          console.log("Productos: ", payload);
          const { sale_order_id: sale_order_id } = await this.postDataWithReturn({ path: "django/portal/make_order/", body: payload });
          // console.log(sale_order_id);

          //desplegar dialog correcto
          this.dialog = true;
          this.error_text = "Pedido realizado correctamente";
          this.alertType = "success";

          //para saber que hay nuevos pedidos
          this.changeNewOrder(true);
        } catch(e) {
          //desplegar dialogo error
          console.error("Error al crear pedido: ", e);
          this.dialog = true;
          this.error_text = "Error al realizar pedido";
          this.alertType = "error";
        } finally {
          this.cargando = false;
          this.repeatingOrder = null;
        }
    },

    closeDetails() {
      this.selectedOrder = null;
      this.selectedOrderIndex = null;
    },
  },
};
</script>
<style scoped>
.grey.lighten-4 {
  background-color: #f8f9fa !important;
}

/* Tarjeta de Pedido */
.order-card {
  border: 1px solid #e0e0e0 !important;
  background: white !important;
  overflow: hidden;
  transition: all 0.3s ease;
}

.order-card:hover {
  border-color: #1976d2 !important;
}

.bg-header {
  background-color: #fcfcfc;
}

.border-top {
  border-top: 1px solid #eee;
}

/* Tipografías */
.tracking-wider {
  letter-spacing: 0.1em;
}

/* Estilo para los filtros superiores */
.state-select >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
}

/* Ajustes Responsive */
@media (min-width: 960px) {
  .border-left-md {
    border-left: 1px solid #eee;
    padding-left: 24px;
  }
}

/* Paginación */
.v-pagination >>> button {
  transition: all 0.2s;
}

.v-pagination >>> .v-pagination__item--active {
  box-shadow: 0 4px 10px rgba(25, 118, 210, 0.3);
}

/* Botón de acción naranja (el mismo del componente artículos) */
.btn-action-confirm {
  background-color: #FF7043 !important;
  color: white !important;
}

.w-100 {
  width: 100%;
}
</style>